import {PaymentsRepository} from '../repository/PaymentsRepository';
import {Payment} from '../models/Payment';

export class GetPaymentsUseCase {
  constructor (private paymentsRepository: PaymentsRepository) {}

  async execute (): Promise<Payment[]> {
    return this.paymentsRepository.getAllPayments();
  }
}
